/* eslint-disable class-methods-use-this */

import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (window.location.hash) this.jumpTo(window.location.hash.slice(1), true);
  }

  jump(event) {
    const { anchor } = event.currentTarget.dataset;

    this.jumpTo(anchor, false);
  }

  jumpTo(anchor, fast) {
    const section = document.getElementById(anchor);

    if (section && fast) {
      section.scrollIntoView();
    } else if (section) {
      const distance = Math.abs(section.getBoundingClientRect().top);
      const delay = Math.min(distance * 0.6, 800);

      section.scrollIntoView({ behavior: "smooth" });
      section.getAnimations().forEach(a => a.cancel());
      setTimeout(() => {
        section.animate(
          [
            { outline: "3px solid #54b5c6", outlineOffset: "2px" },
            { outline: "3px solid #54b5c6", outlineOffset: "2px", offset: 0.7 },
            { outline: "3px solid transparent", outlineOffset: "2px" },
          ],
          { duration: 1500, easing: "ease-out" },
        );
      }, delay);
    }
  }
}
